import { useQuery } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';

export const GET_ANNUAL_PURCHASE_LIST = gql`
  query GetAnnualPurchaseList($input: AnnualPurchaseListInput!) {
    getAnnualPurchaseList(input: $input) {
      count
      results {
        id
        fee
        total
        refund
        subtotal
        discount
        credit
        subtotal
        transfer_id
        charge_id
        card {
          last4
        }
        purchase_date
        status
        user {
          id
          name
          first_name
          last_name
          formatted_name
        }
        users {
          promo
          user {
            id
            name
            first_name
            last_name
          }
          tickets {
            id
            name
            price
            refunded
            type
            barcode
            credited
          }
        }
        international_fee
      }
    }
  }
`;

// Convert YYYY-MM-DD to MM-DD-YYYY for the backend Date scalar
function toBackendDate(dateStr) {
  if (!dateStr) return null;
  const parts = dateStr.split('-');
  if (parts.length === 3 && parts[0].length === 4) {
    return `${parts[1]}-${parts[2]}-${parts[0]}`;
  }
  return dateStr;
}

export function useGetAnnualPurchaseListWithDates(
  ticketId,
  startDate,
  endDate,
  queryString,
  page
) {
  const formattedStartDate = toBackendDate(startDate);
  const formattedEndDate = toBackendDate(endDate);

  return useQuery(GET_ANNUAL_PURCHASE_LIST, {
    variables: {
      input: {
        ticket_id: Number(ticketId),
        ...(page ? { page: String(page) } : null),
        ...(formattedStartDate ? { start_date: formattedStartDate } : null),
        ...(formattedEndDate ? { end_date: formattedEndDate } : null),
        ...(queryString ? { queryString } : null),
      },
    },
    skip: !ticketId,
  });
}
